/* tslint:disable */

/**
 */
export class TicketPrint {
    ticket_number?: number;
    company_fullname?: string;
    company_phone?: string;
    company_tax_code?: string;
    order_code?: string;
    sign?: string;
    company_address?: string;
    route_number?: number;
    staff?: string;
    bus_station?: string;
    price?: number;
    created_at?: string;
}
